// Styles
import "@mdi/font/css/materialdesignicons.css";
import "vuetify/styles";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";
import { VDateInput } from 'vuetify/labs/VDateInput'
import { VTimePicker } from 'vuetify/labs/VTimePicker'

// Vuetify
import { createVuetify } from "vuetify";

export default createVuetify({
  components: {
    ...components,
    VDateInput,
    VTimePicker
  },
  directives
});
